import localforage from "localforage";

localforage.config({
  driver: localforage.LOCALSTORAGE,
});
